//==============================================================================
// スイッチON/OFF
//==============================================================================
document.addEventListener('DOMContentLoaded', function() {
    const switches = document.querySelectorAll('.c-switch');
    switches.forEach(function(switchElement) {
        const switchCheckbox = switchElement.querySelector('input[type="checkbox"]');

        const switchSlider = switchElement.querySelector('.c-switch__slider');
        function updateSliderText() {
            if (switchCheckbox.checked) {
                switchSlider.textContent = switchElement.getAttribute('data-checked');
            }
            else {
                switchSlider.textContent = switchElement.getAttribute('data-unchecked');
            }
        }
        updateSliderText();
        switchCheckbox.addEventListener('change', updateSliderText);
    });
});
